import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Unauthorized from "./pages/Unauthorized";
import PhoneVerification from "./pages/PhoneVerification";
import Login from "./pages/Login";
import "./App.css";
import { AuthProvider } from "./providers/AuthProvider";
import RequiredAuth from "./layouts/RequiredAuth";
import UsersList from "./pages/vendor/UsersList";
import AdminHome from "./pages/admin/AdminHome";
import AddOrEditVendorProfile from "./pages/admin/AddOrEditVendorProfile";
import VendorsList from "./pages/admin/VendorsList";
import CustomerOrdersList from "./pages/vendor/CustomerOrdersList";
import OrdersHistoryList from "./pages/vendor/OrdersHistoryList";
import ProductsList from "./pages/vendor/ProductsList";
import VendorHome from "./pages/vendor/VendorHome";
import ProductDetails from "./pages/vendor/ProductDetails";
import OrderDetails from "./pages/vendor/OrderDetails";
import AddOrEditProduct from "./pages/vendor/AddOrEditProduct";
import CategoriesList from "./pages/vendor/CategoriesList";
import InvoicesList from "./pages/vendor/InvoicesList";
import AdvertisementsList from "./pages/admin/AdvertisementsList";
import Policies from "./pages/Policies";
import ForgotPassword from "./pages/ForgotPassword";
import UserVerification from "./pages/UserVerification";
import ResetPassword from "./pages/ResetPassword";
import AdminUsersList from "./pages/admin/AdminUsersList";
import ForgotPasswordGuard from "./utils/ForgotPasswordGuard";
import VendorCustomersOrdersList from "./pages/admin/VendorCustomersOrdersList";
import CustomersList from "./pages/admin/CustomersList";
import AdminCategoriesList from "./pages/admin/AdminCategoriesList";
import VendorProductsList from "./pages/admin/VendorProductsList";
import CustomersOrdersList from "./pages/admin/CustomersOrdersList";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/reset-password"
        element={
          <ForgotPasswordGuard>
            <ResetPassword />
          </ForgotPasswordGuard>
        }
      />
      <Route
        path="/verify-user"
        element={
          <ForgotPasswordGuard>
            <UserVerification />
          </ForgotPasswordGuard>
        }
      />
      <Route path="/verify" element={<PhoneVerification />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/privacy-and-policy" element={<Policies />} />
      <Route path="/" element={<RequiredAuth routeRole={"SUPERADMIN"} />}>
        <Route index element={<AdminHome />} />
        <Route path="admin" element={<AdminHome />} />
        <Route
          path="admins/users"
          element={<AdminUsersList routeRole={"SUPERADMIN"} />}
        />
        <Route
          path="admins/customers"
          element={<CustomersList routeRole={"SUPERADMIN"} />}
        />
        <Route path="vendors" element={<VendorsList />} />
        <Route path="advertisements" element={<AdvertisementsList />} />
        <Route path="vendors/products" element={<VendorProductsList />} />
        <Route
          path="vendors/products/:productId"
          element={<ProductDetails />}
        />
        <Route
          path="vendors/categories"
          element={<AdminCategoriesList routeRole={"SUPERADMIN"} />}
        />
        <Route
          path="vendors/users"
          element={<UsersList routeRole={"SUPERADMIN"} />}
        />
        <Route path="vendor-info" element={<AddOrEditVendorProfile />} />
        <Route path="customers/orders" element={<CustomersOrdersList />} />
        <Route path="customers/orders/:orderId" element={<OrderDetails />} />
      </Route>

      <Route path="/" element={<RequiredAuth routeRole={"VENDOR"} />}>
        <Route path="vendor" element={<VendorHome />} />
        <Route path="products" element={<ProductsList />} />
        <Route path="products/:productId" element={<ProductDetails />} />
        <Route path="product-info" element={<AddOrEditProduct />} />
        <Route path="categories" element={<CategoriesList />} />
        <Route path="users" element={<UsersList />} />
        <Route path="orders" element={<CustomerOrdersList />} />
        <Route path="orders/:orderId" element={<OrderDetails />} />
        <Route path="invoices" element={<InvoicesList />} />
      </Route>
    </Route>
  )
);
function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
